/**
 * Apresentação pública do produto (§21.12).
 *
 * A quem serve: quem recebeu um link e ainda não tem conta, e quem vai decidir
 * se a organização entra. Por isso ela diz o que o produto FAZ e o que ele NÃO
 * faz — a segunda parte é a que economiza a reunião inútil.
 *
 * Nada aqui promete o que não existe. Uma apresentação que descreve o roadmap
 * como se fosse o presente cria a decepção na primeira semana de uso, que é
 * quando ela custa mais caro.
 */

import { Link } from 'react-router-dom';
import { BRANDING } from '../config/branding';
import { RodapePublico } from '../components/RodapePublico';
import { t } from '../lib/i18n';

export function ApresentacaoPage(): JSX.Element {
  return (
    <div className="mx-auto min-h-screen max-w-3xl px-4 py-10">
      <header>
        <p className="text-2xs uppercase tracking-wider text-ink-subtle">{BRANDING.category}</p>
        <h1 className="mt-1 text-2xl font-semibold text-ink">{BRANDING.productName}</h1>
        <p className="mt-2 text-sm text-ink-muted">{BRANDING.promise}</p>
      </header>

      <section className="mt-8">
        <h2 className="text-sm font-semibold text-ink">{t('sobre.oQueFaz')}</h2>
        <ul className="mt-2 space-y-1.5 text-xs text-ink-muted">
          <li>{t('sobre.faz1')}</li>
          <li>{t('sobre.faz2')}</li>
          <li>{t('sobre.faz3')}</li>
          <li>{t('sobre.faz4')}</li>
        </ul>
      </section>

      <section className="mt-6">
        <h2 className="text-sm font-semibold text-ink">{t('sobre.oQueNaoFaz')}</h2>
        <ul className="mt-2 space-y-1.5 text-xs text-ink-muted">
          <li>{t('sobre.naoFaz1')}</li>
          <li>{t('sobre.naoFaz2')}</li>
          <li>{t('sobre.naoFaz3')}</li>
          <li>{t('sobre.naoFaz4')}</li>
        </ul>
      </section>

      <section className="mt-6">
        <h2 className="text-sm font-semibold text-ink">{t('sobre.comoSeEntra')}</h2>
        <p className="mt-2 text-xs text-ink-muted">
          {t('sobre.comoSeEntraTexto')}
        </p>
        <div className="mt-3 flex flex-wrap gap-2">
          <Link to="/entrar" className="btn-primary btn-sm">
            {t('sobre.entrar')}
          </Link>
          <Link to="/contato" className="btn-secondary btn-sm">
            {t('sobre.falarConosco')}
          </Link>
        </div>
      </section>

      <RodapePublico />
    </div>
  );
}
